<template>
    <div>
        <div class="coffee-search-bar" :class="{'fixed': searchBarFixed}" :style="siteHeaderHeightCssVar" ref="searchBar">
            <div class="coffee-btn-wrapper">
                <coffee-search @paramUpdated="updateSearchParam" ref="search"/>
            </div>
            <div class="coffee-btn-wrapper coffee-sort-btn">
                <coffee-sort :includePriceSort="includePriceSort" :forWorkplace="forWorkplace" @paramUpdated="updateSortParam" :default-option="defaultSortOption" />
            </div>
            <div class="coffee-btn-wrapper">
                <coffee-filter :filterParams="filterParams" :preset-filter-params="presetFilterParams" @paramsUpdated="updateFilterParams" />
            </div>
        </div>
        <div class="place-holder">
        </div>
    </div>
</template>

<script>
    import CoffeeSearch from './coffee-search';
    import CoffeeFilter from './coffee-filter';
    import CoffeeSort from './coffee-sort';

    export default {
        name: "coffee-search-bar",
        components: {
            CoffeeSearch,
            CoffeeFilter,
            CoffeeSort
        },
        props: {
            filterParams: Object,
            topShelf: Boolean,
            includePriceSort: {
                type: Boolean,
                default: false
            },
            forWorkplace: Boolean,
            presetFilterParams: Array,
            defaultSortOption: {
                type: String,
                default: null
            }
        },
        data: () => {
            return {
                queryParams: {
                    'search': undefined,
                    'sort': undefined,
                    'filter': undefined
                },
                searchBarFixed: false,
                siteHeaderHeight: 0,
                topY: 0,
                scrollable: true
            }
        },
        methods: {
            updateSearchParam(param) {
                this.queryParams['search'] = param;
            },
            updateSortParam(param) {
                this.queryParams['sort'] = param;
            },
            updateFilterParams(params, anyParamsAdded) {
                this.queryParams['filter'] = anyParamsAdded ? params : undefined;
            },
            handleScroll() {
                this.searchBarFixed = window.scrollY >= this.topY;
            },
            scrollToTop() {
                window.scroll(0, this.topY);
                this.fix = true;
            },
            isIosSafari() {
                // Check if user's running on Safari on iOS
                const ua = window.navigator.userAgent;
                const iOS = !!ua.match(/iPad/i) || !!ua.match(/iPhone/i);
                const webkit = !!ua.match(/WebKit/i);
                return iOS && webkit && !ua.match(/CriOS/i);
            },
            lockScrollOnFocus() {
                const searchInput = this.$refs.search.$refs.input;

                const scrollOff = (e) => {
                    e.preventDefault();
                };

                searchInput.addEventListener('blur', () => {
                    document.body.removeEventListener('touchmove', scrollOff, { passive: false });
                });

                searchInput.addEventListener('focus', () => {
                    document.body.addEventListener('touchmove', scrollOff, { passive: false });
                });
            }
        },
        watch: {
            queryParams: {
                handler: function () {
                    this.$emit('queryParamsUpdated', this.queryParams);
                },
            deep: true
}
        },
        computed: {
            // Technique to use Vue variables in CSS (https://www.telerik.com/blogs/passing-variables-to-css-on-a-vue-component)
            siteHeaderHeightCssVar() {
                return {
                    '--header-height': this.siteHeaderHeight + 'px'
                }
            }
        },
        mounted() {
            if (!document.getElementById('location-selector-id')){
                var locationElem = 0 ;
            } else{
                var locationElem = document.getElementById('location-selector-id').offsetHeight;
            } 

            const headerElem  = this.forWorkplace ?
                document.getElementById('workplace-site-header').offsetHeight + locationElem :
                document.getElementsByClassName('siteheader')[0].offsetHeight;

            if (!headerElem) {
                console.error('Cannot find the site header element!');
                return;
            }
            this.siteHeaderHeight = headerElem;

            // (Distance between the top of the site and the search bar) - (Header height)
            this.topY = this.forWorkplace ?
                this.$refs.searchBar.offsetTop - this.siteHeaderHeight :
                this.$refs.searchBar.offsetTop;

            window.addEventListener('scroll', this.handleScroll);

            // Due to this 'position: fixed' issue on Safari on iOS: https://gist.github.com/avesus/957889b4941239490c6c441adbe32398,
            // prevent scrolling when user's typing a search keyword.
            if (this.isIosSafari()) {
                this.lockScrollOnFocus();
            }
        }
    }
</script>

<style scoped lang="scss">
    $white: #F4F7F1;
    $max-tablet-width: 768px;

    .coffee-search-bar {
        position: absolute;
        display: grid;
        grid-template-columns: 1fr 1fr 1fr;
        grid-gap: 0.5rem;
        z-index: 1;
        margin: 0;
        width: 100%;
        padding-top: 10px;
        padding-bottom: 10px;
        background-color: $white;
    }
    .coffee-btn-wrapper {
        color: white;
        font-size: 18px;
    }
    .fixed {
        position: fixed;
        top: var(--header-height);
        border-bottom: solid 1px #EEEEEE;
    }
    .place-holder {
        height: 100px;
    }

    @media only screen and (max-width: $max-tablet-width) {
        .coffee-search-bar {
            display: flex;
            flex-direction: row;
            grid-gap: 0;
            width: 100%;
            margin-left: 0;
            margin-right: 0;
            padding-top: 0;
            padding-bottom: 2px;
        }
        .coffee-btn-wrapper {
            width: 33.3%;
            font-size: 16px;
            margin-bottom: 2px;
        }
        .place-holder {
            height: 80px;
        }
    }

    @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
        /* IE10+ CSS styles go here */
        .coffee-search-bar {
            display: flex;
            justify-content: space-between;
        }
        .coffee-btn-wrapper {
            width: 31%;
        }
    }
</style>